var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterSimpleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "c",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M17.53 35.1V19.69L6.97 7.42h28.58L24.99 19.7v10.1l-7.46 5.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSimpleFilled);
export default __webpack_public_path__ + "static/media/filterSimpleFilled.cfbca5981e5d02e3ab315cc756864469.svg";
export { ForwardRef as ReactComponent };